import TextCreate from 'core/display/simple/Text'
import { signal } from 'services/SignalsService'

export default class FreeBetCountText extends TextCreate{
  constructor(data) {
    super(data)

    const freeBetModel = game.models.FreebetsModel.get()
    const freeBetText = this.text._text

    signal.on('FREEBET:SHOW:POPUP', () => {
      super.update(freeBetText.replace('@', freeBetModel.add))
    })
  }
}
